// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../../../common/api'
import { DELETE_LEAVES_ADMIN, EDIT_LEAVES_ADMIN, GET_LEAVES_ADMIN, LEAVES_ADMIN } from '../../../../common/constant'

export const actionLeavesAdmin = createAsyncThunk('appLeavesAdmin/actionLeavesAdmin', async (params, thunkAPI) => {
    return await post(LEAVES_ADMIN, params, thunkAPI)
})

// export const actionAddLeaves = createAsyncThunk('appLeaves/actionAddLeaves', async (params, thunkAPI) => {
//     return await put(ADD_LEAVES, params, thunkAPI)
// })

export const actionGetLeavesAdmin = createAsyncThunk('appLeavesAdmin/actionGetLeavesAdmin', async (params, thunkAPI) => {
    return await post(GET_LEAVES_ADMIN, params, thunkAPI)
})

export const actionEditLeavesAdmin = createAsyncThunk('appLeavesAdmin/actionEditLeavesAdmin', async (params, thunkAPI) => {
    return await post(EDIT_LEAVES_ADMIN, params, thunkAPI)
})

export const actionDeleteLeavesAdmin = createAsyncThunk('appLeavesAdmin/actionDeleteLeavesAdmin', async (params, thunkAPI) => {
    return await post(DELETE_LEAVES_ADMIN, params, thunkAPI)
})

export const appLeavesAdminSlice = createSlice({
    name: 'appLeavesAdmin',
    initialState: {
        //list
        loading: false,
        leavesAdmin: null,

        // //add
        // loadingAdd: false,
        // addLeaves: null,

        //get
        loadingGet: false,
        getLeavesAdmin: null,

        //edit
        loadingEdit: false,
        editLeavesAdmin: null,

        //delete
        loadingDelete: false,
        deleteLeavesAdmin: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetLeavesAdminResponse: (state) => {
            state.leavesAdmin = null
        },
        // resetAddLeavesAdminResponse: (state) => {
        //     state.addLeavesAdmin = null
        // },
        resetGetLeavesAdminResponse: (state) => {
            state.getLeavesAdmin = null
        },
        resetEditLeavesAdminResponse: (state) => {
            state.editLeavesAdmin = null
        },
        resetDeleteLeavesAdminResponse: (state) => {
            state.deleteLeavesAdmin = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionLeavesAdmin.pending, (state) => {
                state.loading = true
            })
            .addCase(actionLeavesAdmin.fulfilled, (state, action) => {
                state.loading = false
                state.leavesAdmin = action.payload
            })
            .addCase(actionLeavesAdmin.rejected, (state) => {
                state.loading = false
            })

            // //add
            // .addCase(actionAddLeavesAdmin.pending, (state) => {
            //     state.loadingAdd = true
            // })
            // .addCase(actionAddLeavesAdmin.fulfilled, (state, action) => {
            //     state.loadingAdd = false
            //     state.addLeavesAdmin = action.payload
            // })
            // .addCase(actionAddLeavesAdmin.rejected, (state) => {
            //     state.loadingAdd = false
            // })

            //get
            .addCase(actionGetLeavesAdmin.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetLeavesAdmin.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getLeavesAdmin = action.payload
            })
            .addCase(actionGetLeavesAdmin.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditLeavesAdmin.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditLeavesAdmin.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editLeavesAdmin = action.payload
            })
            .addCase(actionEditLeavesAdmin.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteLeavesAdmin.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteLeavesAdmin.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteLeavesAdmin = action.payload
            })
            .addCase(actionDeleteLeavesAdmin.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetLeavesAdminResponse, resetGetLeavesAdminResponse, resetEditLeavesAdminResponse, resetDeleteLeavesAdminResponse } = appLeavesAdminSlice.actions

export default appLeavesAdminSlice.reducer